import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export function ThemeToggle({ className = "" }) {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === "light";
  return (
    <button
      onClick={toggleTheme}
      data-testid="theme-toggle"
      aria-label={isLight ? "Switch to Dark Neon theme" : "Switch to Viator Light theme"}
      title={isLight ? "Switch to Dark Neon" : "Switch to Viator Light"}
      className={`relative w-9 h-9 rounded-full glass flex items-center justify-center text-slate-300 hover:text-cyan-400 transition-colors ${className}`}
    >
      {isLight ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
}
